/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FC, ReactNode } from 'react';
import Loader from '~components/atoms/Loader/Loader';
import { FileViewerMargins } from '~src/contexts/FileToViewContext';
import { useStyles } from '~src/hooks/useStyles';
import { EStyleObj } from '~src/types';

type RightSideViewerContainerProps = {
  ViewerItem: ReactNode;
  MainContent: ReactNode;
  isViewerLoading?: boolean;
  bottomViewHeight: number;
  previewContainerStyles?: EStyleObj;
  viewerTopMargin?: FileViewerMargins;
};

const RightSideViewerContainer: FC<RightSideViewerContainerProps> = ({
  ViewerItem,
  MainContent,
  isViewerLoading,
  bottomViewHeight,
  previewContainerStyles,
  viewerTopMargin,
}) => {
  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: '50%', overflowX: 'scroll' }}>{MainContent}</div>
      <div
        css={[previewContainerStyles]}
        style={{
          width: '50%',
          height: `calc(100vh - 83px - ${bottomViewHeight}px)`,
          overflowX: 'scroll',
          marginTop: viewerTopMargin || 0,
          ...previewContainerStyles,
        }}
        onContextMenu={(e) => e.stopPropagation()}>
        {isViewerLoading ? <Loader /> : ViewerItem}
      </div>
    </div>
  );
};

export default RightSideViewerContainer;
